export default __webpack_public_path__ + "ca907b4a0751b74779e987ae3e703e59.jpg";